import { useEffect } from "react";
import { Link } from "react-router-dom";
import clsx from "clsx";
import { useActor, useMachine } from "@xstate/react";
import { Icon } from "../SVGsprite/svgsprite";
import styles from "./MyOrdersList.module.scss";
import { Loader } from "../Loader/Loader";
import { Pagination } from "../Pagination/Pagination";
import { Banners } from "../Banners/Banners";
import { Bonuses } from "../Bonuses/Bonuses";
import { NoData } from "../NoData/NoData";
import { AuthState } from "../../xstate/auth.machine";
import { myOrdersListMachine } from "../../xstate/myorderslist.machine";

// В MyOrdersList.js, добавьте обработку состояния failure:
export function MyOrdersList() {
	const [stateAuth] = useActor(AuthState);
	const [stateOrders, sendOrders] = useMachine(myOrdersListMachine);

	useEffect(() => {
		document.title = "Мои заказ-наряды | Программа лояльности SK ZIC";
	}, []);

	// Функция для повторной загрузки
	const handleRetry = () => {
		sendOrders({ type: "retry" });
	};

	if (
		stateAuth.context.type == "seller" &&
		stateAuth.context.service_order_verification_status === "enabled"
	) {
		return (
			<>
				<section className={styles.workarea}>
					<div className="titleBlock">
						<h1>Мои заказ-наряды</h1>
						{!["owner", "distributor"].includes(stateAuth.context.type) && (
							<Link
								to="/account/order-upload"
								className="btn btnPrimary btnIcon"
							>
								<Icon name="icon-add" sizeW="24" sizeH="24" />
								Загрузить заказ-наряд
							</Link>
						)}
					</div>

					<div className="statContainer">
						{stateOrders.matches("loading") && <Loader />}

						{stateOrders.matches("success") && (
							<>
								<OrdersTable data={stateOrders.context.list} />
								{(stateOrders.context.meta?.lastPage > 1 ||
									stateOrders.context.meta?.pages > 1) && (
									<Pagination
										pages={stateOrders.context.pages}
										current_page={stateOrders.context.current_page}
										send={sendOrders}
									/>
								)}
							</>
						)}

						{stateOrders.matches("failure") && (
							<div className={styles.errorContainer}>
								<p>Ошибка загрузки данных: {stateOrders.context.errorMsg}</p>
								<button onClick={handleRetry} className="btn btnPrimary">
									Повторить
								</button>
							</div>
						)}
					</div>
				</section>
				<aside className={styles.sidebar}>
					<Banners />
				</aside>
			</>
		);
	}

	return <></>;
}

function OrdersTable(props) {
	if (props.data.length === 0) {
		return <NoData />;
	}
	console.log("props", props);
	return (
		<div className="scrollbox">
			<table className="statTable">
				<thead>
					<tr>
						{/* <th>Дата загрузки чека</th> */}
						<th>Номер и дата заказ-наряда</th>
						<th>Фото документа</th>
						<th>Состав заказа</th>
						<th>Статус</th>
						<th>Баллы</th>
					</tr>
				</thead>
				<tbody>
					{props.data.map(item => (
						<tr key={item.id}>
							{/* <td>{new Date(item.created_at).toLocaleString()}</td> */}

							<td>
								<div>
									<b>{item.number}</b>
								</div>
								<div>{new Date(item.creation_date).toLocaleString()}</div>
							</td>
							<td className={styles.imgTD}>
								{item.photos && item.photos[0] && item.photos[0].path !== "" ? (
									<img src={item.photos[0].path} alt="Фото документа" />
								) : (
									"Фото временно недоступно"
								)}
							</td>
							<td>
								{item.goods &&
									item.goods.map((good, index) => (
										<div key={index}>
											{good}
											{index < item.goods.length - 1 && <br />}
										</div>
									))}
							</td>
							<td className={styles.status}>
								<span
									className={clsx(styles.statusButton, {
										[styles.stateDeclined]: item.status.slug === "reject",
										[styles.stateProcessing]: item.status.slug === "in_process",
										[styles.stateAccepted]: item.status.slug === "approve",
									})}
								>
									{item.description && item.description.length > 2
										? "Отклонен. Дубликат чека."
										: item.status.i18n}
								</span>
								{item.status.slug === "reject" && (
									<a
										target="_blank"
										rel="noopener noreferrer"
										href="/feedback?zn=42345234"
									>
										Связаться с поддержкой
									</a>
								)}
							</td>
							<td>{item.points}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
}
